import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/cancellation'

const initialState = () => ({
    cancellations: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        cancellations: state => state.cancellations.data,
        pagination: state => state.cancellations.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listCancellations: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listCancellations(data)
                const cancellations = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_CANCELLATIONS, cancellations)
                return cancellations
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetCancellations: ({commit}) => commit(mutationTypes.RESET_CANCELLATIONS)
    },
    mutations: {
        [mutationTypes.RESET_CANCELLATIONS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_CANCELLATIONS]: (state, data) => state.cancellations = data
    }
}
